/* @flow */
import React from 'react';

import ActivityForm from 'payments/components/ActivityForm.jsx';
import PageControls from 'payments/components/PageControls.jsx';
import Activity from 'entities/Activity';
import CurrentUser from 'auth/CurrentUser';

import './styles/ActivityAnnouncementAdditionalDetailForm.scss';

const CENTS_IN_DOLLAR = 100;

type Props = {
  onBack: () => void,
  onNext: (data: {location: ?string, date: ?Date, amount: ?number}) => void,
  withoutAmountInput?: ?boolean,
  amount?: ?number,
  location: ?string,
  date: ?Date,
  endDate?: ?Date,
};

type State = {
  amount: ?number,
  location: ?string,
  date: ?Date,
  endDate: ?Date,
};

class ActivityAnnouncementAdditionalDetailForm extends React.Component {
  props: Props;
  state: State = {
    amount: this.props.amount,
    location: this.props.location,
    date: this.props.date,
    endDate: this.props.endDate,
  };

  setStateFromValues: Function = (values, onSetState): void => {
    this.setState({
      location: values.location,
      date: values.date,
      endDate: values.end_date,
      amount: values.amount * CENTS_IN_DOLLAR,
    }, onSetState);
  }

  onChange: Function = (values): void => {
    this.setStateFromValues(values);
  };

  onBack: Function = (): void => {
    const amount = this.props.withoutAmountInput ? {} : { amount: this.state.amount };
    this.props.onBack({
      location: this.state.location,
      date: this.state.date,
      endDate: this.state.endDate,
      ...amount,
    });
  };

  onValidSubmit: Function = (values): void => {
    this.setStateFromValues(values, () => {
      const amount = this.props.withoutAmountInput ? {} : { amount: this.state.amount };
      this.props.onNext({
        location: this.state.location,
        date: this.state.date,
        endDate: this.state.endDate,
        ...amount,
      });
    });
  };

  render() {
    let initialActivity;
    if (this.state.location || this.state.date || this.state.endDate || this.state.amount) {
      initialActivity = Activity.fromJSON({
        location: this.state.location,
        start_at: this.state.date,
        amount_per_person: this.state.amount,
        end_at: this.state.endDate,
      });
    }

    const canCollectMoney = (
      CurrentUser.isSignedIn() &&
      CurrentUser.getUser().canCollectMoney()
    );

    return (
      <div className="ActivityAnnouncementAdditionalDetailForm">
        <ActivityForm
          showLabels
          canCollectMoney={canCollectMoney && !this.props.withoutAmountInput}
          showTitleField={false}
          showWelcomeMsgBodyField={false}
          showCheckboxFields={false}
          submitText="Next"
          initialActivity={initialActivity}
          onValidSubmit={this.onValidSubmit}
          onChange={this.onChange}
        />
        <PageControls
          className="ActivityAnnouncementAdditionalDetailForm-controls"
          onBack={this.onBack}
        />
      </div>
    );
  }
}

export default ActivityAnnouncementAdditionalDetailForm;



// WEBPACK FOOTER //
// ./src/payments/components/ActivityAnnouncementAdditionalDetailForm.jsx